import { api } from '../lib/api'
import type { User } from '../lib/types'

export const authApi = {
  login: (email: string, password: string, turnstileToken?: string) =>
    api.post<{ user: User }>('/auth/login', { email, password, turnstileToken }),
  logout: () => api.post<{ ok: true }>('/auth/logout', {}),
  me: () => api.get<{ user: User }>('/auth/me'),
  turnstileConfig: () => api.get<{ siteKey: string | null }>('/auth/turnstile'),
}
